import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class CoffeeScene extends MinigameScene {
    //Images
    private endAnimation !: object;
    private endImage !: Phaser.GameObjects.Image;

    //values
    private ingredientConfig = [
        {cupImage: CONST.COFFEE.CUP_COFFEE, normalImage: CONST.COFFEE.NORMAL_COFFEE, startX: 99, startY: 108, correct: true},
        {cupImage: CONST.COFFEE.CUP_EGG, normalImage: CONST.COFFEE.NORMAL_EGG, startX: 525, startY: 68, correct: false},
        {cupImage: CONST.COFFEE.CUP_MILK, normalImage: CONST.COFFEE.NORMAL_MILK, startX: 780, startY: 386, correct: true},
        {cupImage: CONST.COFFEE.CUP_PEPPER, normalImage: CONST.COFFEE.NORMAL_PEPPER, startX: 201, startY: 191, correct: false},
        {cupImage: CONST.COFFEE.CUP_SALT, normalImage: CONST.COFFEE.NORMAL_SALT, startX: 650, startY: 167, correct: false},
        {cupImage: CONST.COFFEE.CUP_SCREW, normalImage: CONST.COFFEE.NORMAL_SCREW, startX: 174, startY: 380, correct: false},
        {cupImage: CONST.COFFEE.CUP_SUGAR, normalImage: CONST.COFFEE.NORMAL_SUGAR, startX: 771, startY: 91, correct: true},
        {cupImage: CONST.COFFEE.CUP_TOMATO, normalImage: CONST.COFFEE.NORMAL_TOMATO, startX: 52, startY: 279, correct: false},
        {cupImage: CONST.COFFEE.CUP_CHEESE, normalImage: CONST.COFFEE.NORMAL_CHEESE, startX: 644, startY: 322, correct: false},
    ];

    private cupPosition = {x: 426.5, y: 240};
    private maxCupDistance = 85.33;

    private animFPS = 60;


    //logic vars
    private ingredients = [];
    private cupIngredientDepth = 10;
    private correctCounter = 0;
    private wrongCounter = 0;

    private animTimer = 0;
    private isAnimating = false;

    constructor(){
        super ({
            sceneName: CONST.SCENES.COFFEE,
            duration: 6000,
            startScreenColor: 0xFF9090,
            startText: "INTERN!",
            startTextColor: 0x323232,
            endScreen: CONST.COFFEE.END,
            nextScene: CONST.SCENES.MARRIAGE,
            endButtons: {
                normalNoSkip: {x: 439, y: 368, scale: 1.25},
                normalWithSkip: {x: 300, y: 368, scale: 1.25},
                skip: {x: 589, y: 368, scale: 1.25}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.ingredients = [];
        this.cupIngredientDepth = 10;
        this.correctCounter = 0;
        this.wrongCounter = 0;
        this.animTimer = 0;
        this.isAnimating = false;
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.COFFEE.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(426.5, 431, CONST.COFFEE.MAKECOFFEETEXT).setDepth(1);

        this.spawnIngredients();

        this.endAnimation = this.cache.json.get(CONST.ANIMATIONS.COFFEEEND);
    }

    private spawnIngredients(){
        this.ingredientConfig.forEach(config => {
            var cupIngredient = this.add.image(this.cupPosition.x, this.cupPosition.y, config.cupImage).setVisible(false);

            var normalIngredient = this.add.image(config.startX, config.startY, config.normalImage)
                                            .setDepth(50)
                                            .setInteractive(this.input.makePixelPerfect());

            this.input.setDraggable(normalIngredient);

            this.ingredients.push({key: config.normalImage,
                                    normal: normalIngredient, 
                                    cup: cupIngredient, 
                                    correct: config.correct,
                                    putInCup: (ingredient, depth) => {
                                        ingredient.normal.setActive(false).setVisible(false);
                                        ingredient.cup.setVisible(true).setDepth(depth);

                                        if (ingredient.correct){
                                            this.correctCounter++;
                                        } else {
                                            this.wrongCounter++;
                                        }
                                        //console.log("puting in cup!!");
                                    }});
        });

        this.input.on('dragstart', function (pointer, gameObject) {
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;

            this.children.bringToTop(gameObject);
            this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
        }, this);

        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });

        this.input.on('dragend', function(pointer, gameObject, dropped){
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;

            this.PutInCup(gameObject);
            this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
        }, this);
    }

    private PutInCup(gameObject: Phaser.GameObjects.Image){
        var distanceToCup = Phaser.Math.Distance.Between(gameObject.x, gameObject.y, this.cupPosition.x, this.cupPosition.y);
        //console.log("Distance to cup: " + distanceToCup);

        if (distanceToCup > this.maxCupDistance) return;

        this.ingredients.forEach((ingredient) => {
            if (ingredient.key === gameObject.texture.key){
                this.cupIngredientDepth += 1;

                ingredient.putInCup(ingredient, this.cupIngredientDepth);
                return;
            }
        })
    }

    _update(time: number, delta: number){
        if (this.isAnimating){
            this.animTimer += delta;
            this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimation);
        }
    }

    _timeout(){
        this.checkForWin();
    }

    private checkForWin(){
        if (this.correctCounter == 3 && this.wrongCounter == 0){
            this.triggerWin();
        } else {
            this.triggerLoss();
        }
    }
    _afterLoss(){
        this.hideIngredients();
    }

    _afterWin(){
        this.hideIngredients();
    }

    private hideIngredients(){
        this.ingredients.forEach(ingredient => {
            ingredient.normal.setVisible(false);
            ingredient.cup.setVisible(false);
        });
    }

    private triggerWin(){
        this.winGame(1500);
        this.endGameAnim(true);
    }

    private triggerLoss(){
        this.loseGame(1500);
        this.endGameAnim(false);
    }

    private endGameAnim(win: boolean){
        var imageKey = win ? CONST.COFFEE.WINIMAGE : CONST.COFFEE.LOSEIMAGE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }

    private positionImageOnAnimation(timer: number, image: Phaser.GameObjects.Image, animation: object, xOffset: number = 0, yOffset: number = 0, angleOffset: number = 0, scaleMultiplier: number = 1){
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length){
            frameIndex = animation.frames.length - 1;
        }

        var frame = animation.frames[frameIndex];

        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset)
            .setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier)
            .setAngle(parseFloat(frame.angle) + angleOffset);
    }
}
